﻿[
  {
    "draftJersey": "042",
    "name": "Adara Torres",
    "age": 28,
    "foot": "right",
    "height": 158,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/042.jpg",
    "macros": {
      "speed": 75,
      "passing": 64,
      "physical": 51,
      "shooting": 67,
      "talent": 71,
      "defence": 69
    },
    "profileYtVideoId": "oIEazUVh0A4",
    "matchYtVideoId": "fbq3tGzg4TA"
  },
  {
    "draftJersey": "043",
    "name": "Marina Sonet",
    "age": 23,
    "foot": "right",
    "height": 168,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/043.jpg",
    "macros": {
      "speed": 82,
      "passing": 45,
      "physical": 54,
      "shooting": 82,
      "talent": 70,
      "defence": 62
    },
    "profileYtVideoId": "eV_wq1XIrgg",
    "matchYtVideoId": "fbq3tGzg4TA"
  },
  {
    "draftJersey": "044",
    "name": "Aina Moya",
    "age": 25,
    "foot": "right",
    "height": 159,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/044.jpg",
    "macros": {
      "speed": 76,
      "passing": 43,
      "physical": 51,
      "shooting": 87,
      "talent": 77,
      "defence": 70
    },
    "profileYtVideoId": "e1bXptUhR5A",
    "matchYtVideoId": "fbq3tGzg4TA"
  },
  {
    "draftJersey": "045",
    "name": "Sara Ismael",
    "age": 24,
    "foot": "right",
    "height": 163,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/045.jpg",
    "macros": {
      "speed": 78,
      "passing": 75,
      "physical": 55,
      "shooting": 81,
      "talent": 72,
      "defence": 61
    },
    "profileYtVideoId": "BRKFj3dRdBw",
    "matchYtVideoId": "UtNVRuD9tYk"
  },
  {
    "draftJersey": "046",
    "name": "Alicia Hernández",
    "age": 20,
    "foot": "left",
    "height": 168,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/046.jpg",
    "macros": {
      "speed": 79,
      "passing": 64,
      "physical": 50,
      "shooting": 83,
      "talent": 77,
      "defence": 71
    },
    "profileYtVideoId": "5UO8zyCwTGM",
    "matchYtVideoId": "YFY343Riwrw"
  },
  {
    "draftJersey": "047",
    "name": "Adriana Ruiz",
    "age": 26,
    "foot": "left",
    "height": 165,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/047.jpg",
    "macros": {
      "speed": 75,
      "passing": 73,
      "physical": 52,
      "shooting": 87,
      "talent": 71,
      "defence": 73
    },
    "profileYtVideoId": "Ij3twoz2IIM",
    "matchYtVideoId": "YFY343Riwrw"
  },
  {
    "draftJersey": "048",
    "name": "Ainhoa Alonso",
    "age": 26,
    "foot": "right",
    "height": 170,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/048.jpg",
    "macros": {
      "speed": 77,
      "passing": 80,
      "physical": 61,
      "shooting": 73,
      "talent": 69,
      "defence": 66
    },
    "profileYtVideoId": "UYRo_-gFcXs",
    "matchYtVideoId": "UtNVRuD9tYk"
  },
  {
    "draftJersey": "049",
    "name": "Raquel Guerra",
    "age": 29,
    "foot": "right",
    "height": 160,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/049.jpg",
    "macros": {
      "speed": 80,
      "passing": 82,
      "physical": 65,
      "shooting": 84,
      "talent": 83,
      "defence": 77
    },
    "profileYtVideoId": "WxIr-c4Q_wM",
    "matchYtVideoId": "fbq3tGzg4TA"
  },
  {
    "draftJersey": "050",
    "name": "Abril del Toro",
    "age": 21,
    "foot": "right",
    "height": 160,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/050.jpg",
    "macros": {
      "speed": 81,
      "passing": 60,
      "physical": 58,
      "shooting": 68,
      "talent": 75,
      "defence": 67
    },
    "profileYtVideoId": "tTEDgWapkKc",
    "matchYtVideoId": "YFY343Riwrw"
  },
  {
    "draftJersey": "051",
    "name": "Aitana Camúñez",
    "age": 19,
    "foot": "right",
    "height": 165,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/051.jpg",
    "macros": {
      "speed": 77,
      "passing": 58,
      "physical": 49,
      "shooting": 93,
      "talent": 74,
      "defence": 73
    },
    "profileYtVideoId": "0Ja_qskIopU",
    "matchYtVideoId": "YFY343Riwrw"
  },
  {
    "draftJersey": "053",
    "name": "Andrea Martínez",
    "age": 23,
    "foot": "right",
    "height": 163,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/053.jpg",
    "macros": {
      "speed": 83,
      "passing": 56,
      "physical": 65,
      "shooting": 81,
      "talent": 69,
      "defence": 67
    },
    "profileYtVideoId": "3enosG219SM",
    "matchYtVideoId": "UtNVRuD9tYk"
  },
  {
    "draftJersey": "054",
    "name": "Aroney González",
    "age": 21,
    "foot": "right",
    "height": 164,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/054.jpg",
    "macros": {
      "speed": 81,
      "passing": 74,
      "physical": 61,
      "shooting": 81,
      "talent": 72,
      "defence": 71
    },
    "profileYtVideoId": "4e3q9K75b8Y",
    "matchYtVideoId": "YFY343Riwrw"
  },
  {
    "draftJersey": "055",
    "name": "Bárbara Fuentes",
    "age": 22,
    "foot": "right",
    "height": 165,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/055.jpg",
    "macros": {
      "speed": 80,
      "passing": 56,
      "physical": 49,
      "shooting": 77,
      "talent": 69,
      "defence": 78
    },
    "profileYtVideoId": "HtMhjpIO_AE",
    "matchYtVideoId": "YFY343Riwrw"
  },
  {
    "draftJersey": "056",
    "name": "Alba Oliver",
    "age": 21,
    "foot": "right",
    "height": 160,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/056.jpg",
    "macros": {
      "speed": 79,
      "passing": 64,
      "physical": 66,
      "shooting": 90,
      "talent": 70,
      "defence": 71
    },
    "profileYtVideoId": "Ys_kDbTQ8xs",
    "matchYtVideoId": "UtNVRuD9tYk"
  },
  {
    "draftJersey": "057",
    "name": "Alba Pomares",
    "age": 28,
    "foot": "right",
    "height": 159,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/057.jpg",
    "macros": {
      "speed": 80,
      "passing": 63,
      "physical": 60,
      "shooting": 80,
      "talent": 76,
      "defence": 63
    },
    "profileYtVideoId": "5NKyA2Rk45Q",
    "matchYtVideoId": "fbq3tGzg4TA"
  },
  {
    "draftJersey": "058",
    "name": "Alexandra García",
    "age": 20,
    "foot": "right",
    "height": 158,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/058.jpg",
    "macros": {
      "speed": 82,
      "passing": 73,
      "physical": 63,
      "shooting": 79,
      "talent": 79,
      "defence": 69
    },
    "profileYtVideoId": "-tMEl3ElYFk",
    "matchYtVideoId": "fbq3tGzg4TA"
  },
  {
    "draftJersey": "059",
    "name": "Alexandra Giró",
    "age": 23,
    "foot": "right",
    "height": 163,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/059.jpg",
    "macros": {
      "speed": 81,
      "passing": 59,
      "physical": 52,
      "shooting": 77,
      "talent": 83,
      "defence": 66
    },
    "profileYtVideoId": "yN61agfKXSQ",
    "matchYtVideoId": "fbq3tGzg4TA"
  },
  {
    "draftJersey": "060",
    "name": "Alba Guerrero",
    "age": 31,
    "foot": "right",
    "height": 168,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/060.jpg",
    "macros": {
      "speed": 83,
      "passing": 63,
      "physical": 51,
      "shooting": 86,
      "talent": 77,
      "defence": 74
    },
    "profileYtVideoId": "peDMwMFpDDE",
    "matchYtVideoId": "fbq3tGzg4TA"
  },
  {
    "draftJersey": "061",
    "name": "Andrea López",
    "age": 26,
    "foot": "right",
    "height": 155,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/061.jpg",
    "macros": {
      "speed": 85,
      "passing": 57,
      "physical": 61,
      "shooting": 89,
      "talent": 75,
      "defence": 64
    },
    "profileYtVideoId": "vuc35wXYGBI",
    "matchYtVideoId": "8cysd-M2uQE"
  },
  {
    "draftJersey": "062",
    "name": "Anna Soto",
    "age": 30,
    "foot": "right",
    "height": 163,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/062.jpg",
    "macros": {
      "speed": 69,
      "passing": 80,
      "physical": 46,
      "shooting": 74,
      "talent": 73,
      "defence": 76
    },
    "profileYtVideoId": "yUY-5lFR6m4",
    "matchYtVideoId": "fbq3tGzg4TA"
  },
  {
    "draftJersey": "063",
    "name": "Berta Velasco",
    "age": 35,
    "foot": "left",
    "height": 160,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/063.jpg",
    "macros": {
      "speed": 86,
      "passing": 65,
      "physical": 63,
      "shooting": 81,
      "talent": 70,
      "defence": 74
    },
    "profileYtVideoId": "L_DTGDRrcyg",
    "matchYtVideoId": "YFY343Riwrw"
  },
  {
    "draftJersey": "064",
    "name": "Carla Bartolomé",
    "age": 34,
    "foot": "right",
    "height": 170,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/064.jpg",
    "macros": {
      "speed": 84,
      "passing": 59,
      "physical": 67,
      "shooting": 83,
      "talent": 71,
      "defence": 74
    },
    "profileYtVideoId": "oMstVC2FIeQ",
    "matchYtVideoId": "UtNVRuD9tYk"
  },
  {
    "draftJersey": "065",
    "name": "Martina Pubill",
    "age": 17,
    "foot": "right",
    "height": 177,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/065.jpg",
    "macros": {
      "speed": 82,
      "passing": 62,
      "physical": 71,
      "shooting": 74,
      "talent": 83,
      "defence": 80
    },
    "profileYtVideoId": "F4idOKGQ3ks",
    "matchYtVideoId": "8cysd-M2uQE"
  },
  {
    "draftJersey": "066",
    "name": "Carla Torras",
    "age": 26,
    "foot": "left",
    "height": 164,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/066.jpg",
    "macros": {
      "speed": 77,
      "passing": 63,
      "physical": 56,
      "shooting": 72,
      "talent": 72,
      "defence": 65
    },
    "profileYtVideoId": "WElHa6jpY-U",
    "matchYtVideoId": "UtNVRuD9tYk"
  },
  {
    "draftJersey": "067",
    "name": "Pati Ruano",
    "age": 23,
    "foot": "right",
    "height": 167,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/067.jpg",
    "macros": {
      "speed": 68,
      "passing": 41,
      "physical": 58,
      "shooting": 66,
      "talent": 77,
      "defence": 75
    },
    "profileYtVideoId": "8oSWR5J_IxE",
    "matchYtVideoId": "DfatJdKAVnk"
  },
  {
    "draftJersey": "068",
    "name": "Adriana Quer",
    "age": 32,
    "foot": "right",
    "height": 163,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/068.jpg",
    "macros": {
      "speed": 75,
      "passing": 45,
      "physical": 59,
      "shooting": 82,
      "talent": 79,
      "defence": 69
    },
    "profileYtVideoId": "IWc59Lhn8wM",
    "matchYtVideoId": "UtNVRuD9tYk"
  },
  {
    "draftJersey": "069",
    "name": "Ana Alcocer",
    "age": 27,
    "foot": "right",
    "height": 163,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/069.jpg",
    "macros": {
      "speed": 80,
      "passing": 76,
      "physical": 69,
      "shooting": 86,
      "talent": 80,
      "defence": 67
    },
    "profileYtVideoId": "DPjlrmLm32M",
    "matchYtVideoId": "8cysd-M2uQE"
  },
  {
    "draftJersey": "070",
    "name": "Antonela Romoleroux",
    "age": 19,
    "foot": "left",
    "height": 157,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/070.jpg",
    "macros": {
      "speed": 79,
      "passing": 62,
      "physical": 76,
      "shooting": 66,
      "talent": 77,
      "defence": 74
    },
    "profileYtVideoId": "4lvQtrnRj_8",
    "matchYtVideoId": "fbq3tGzg4TA"
  },
  {
    "draftJersey": "071",
    "name": "Berta Thió",
    "age": 27,
    "foot": "right",
    "height": 170,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/071.jpg",
    "macros": {
      "speed": 71,
      "passing": 80,
      "physical": 64,
      "shooting": 53,
      "talent": 73,
      "defence": 73
    },
    "profileYtVideoId": "vkqbAkoRNxE",
    "matchYtVideoId": "8cysd-M2uQE"
  },
  {
    "draftJersey": "073",
    "name": "Carmen Cazalla",
    "age": 22,
    "foot": "left",
    "height": 164,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/073.jpg",
    "macros": {
      "speed": 78,
      "passing": 49,
      "physical": 36,
      "shooting": 68,
      "talent": 75,
      "defence": 73
    },
    "profileYtVideoId": "Vxb07sWlVEI",
    "matchYtVideoId": "8cysd-M2uQE"
  },
  {
    "draftJersey": "074",
    "name": "Clara Martinez",
    "age": 20,
    "foot": "right",
    "height": 163,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/074.jpg",
    "macros": {
      "speed": 72,
      "passing": 61,
      "physical": 63,
      "shooting": 63,
      "talent": 76,
      "defence": 75
    },
    "profileYtVideoId": "x5ddVtvk3AQ",
    "matchYtVideoId": "8cysd-M2uQE"
  },
  {
    "draftJersey": "075",
    "name": "Clara Sanz",
    "age": 24,
    "foot": "right",
    "height": 170,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/075.jpg",
    "macros": {
      "speed": 80,
      "passing": 80,
      "physical": 69,
      "shooting": 75,
      "talent": 78,
      "defence": 70
    },
    "profileYtVideoId": "FAIuBKErtr0",
    "matchYtVideoId": "8cysd-M2uQE"
  },
  {
    "draftJersey": "076",
    "name": "Claudia Sardiña",
    "age": 22,
    "foot": "right",
    "height": 160,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/076.jpg",
    "macros": {
      "speed": 78,
      "passing": 82,
      "physical": 72,
      "shooting": 91,
      "talent": 78,
      "defence": 72
    },
    "profileYtVideoId": "eNup-V_5a6E",
    "matchYtVideoId": "8cysd-M2uQE"
  },
  {
    "draftJersey": "077",
    "name": "Ana Hernández",
    "age": 22,
    "foot": "right",
    "height": 173,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/077.jpg",
    "macros": {
      "speed": 76,
      "passing": 56,
      "physical": 63,
      "shooting": 87,
      "talent": 84,
      "defence": 74
    },
    "profileYtVideoId": "T25H5DBiUzM",
    "matchYtVideoId": "8cysd-M2uQE"
  },
  {
    "draftJersey": "078",
    "name": "Montse Amella",
    "age": 20,
    "foot": "right",
    "height": 170,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/078.jpg",
    "macros": {
      "speed": 80,
      "passing": 60,
      "physical": 55,
      "shooting": 60,
      "talent": 71,
      "defence": 73
    },
    "profileYtVideoId": "IZwdZG70Xbo",
    "matchYtVideoId": "UtNVRuD9tYk"
  },
  {
    "draftJersey": "079",
    "name": "Andrea González",
    "age": 20,
    "foot": "right",
    "height": 157,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/079.jpg",
    "macros": {
      "speed": 79,
      "passing": 45,
      "physical": 60,
      "shooting": 78,
      "talent": 80,
      "defence": 80
    },
    "profileYtVideoId": "TAn-4FMUkxw",
    "matchYtVideoId": "YFY343Riwrw"
  },
  {
    "draftJersey": "080",
    "name": "Andrea Márquez",
    "age": 22,
    "foot": "right",
    "height": 165,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/080.jpg",
    "macros": {
      "speed": 77,
      "passing": 48,
      "physical": 50,
      "shooting": 89,
      "talent": 70,
      "defence": 66
    },
    "profileYtVideoId": "0XYVptODw9k",
    "matchYtVideoId": "YFY343Riwrw"
  },
  {
    "draftJersey": "081",
    "name": "Clara Dueñas",
    "age": 21,
    "foot": "right",
    "height": 156,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/081.jpg",
    "macros": {
      "speed": 77,
      "passing": 64,
      "physical": 58,
      "shooting": 90,
      "talent": 69,
      "defence": 71
    },
    "profileYtVideoId": "OfkGisoNBpQ",
    "matchYtVideoId": "UtNVRuD9tYk"
  },
  {
    "draftJersey": "082",
    "name": "Clara Rodríguez",
    "age": 28,
    "foot": "right",
    "height": 164,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/082.jpg",
    "macros": {
      "speed": 81,
      "passing": 43,
      "physical": 49,
      "shooting": 80,
      "talent": 67,
      "defence": 71
    },
    "profileYtVideoId": "Ae-_9RObFKQ",
    "matchYtVideoId": "YFY343Riwrw"
  },
  {
    "draftJersey": "083",
    "name": "Corina Durante",
    "age": 24,
    "foot": "right",
    "height": 153,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/083.jpg",
    "macros": {
      "speed": 79,
      "passing": 43,
      "physical": 47,
      "shooting": 81,
      "talent": 69,
      "defence": 64
    },
    "profileYtVideoId": "JtnNtkfoc9w",
    "matchYtVideoId": "YFY343Riwrw"
  },
  {
    "draftJersey": "084",
    "name": "Coral Amate",
    "age": 19,
    "foot": "right",
    "height": 167,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/084.jpg",
    "macros": {
      "speed": 80,
      "passing": 60,
      "physical": 64,
      "shooting": 70,
      "talent": 78,
      "defence": 77
    },
    "profileYtVideoId": "ODH3gHG9cq8",
    "matchYtVideoId": "J8M2WtRnSIo"
  },
  {
    "draftJersey": "085",
    "name": "Coral Fernández",
    "age": 23,
    "foot": "right",
    "height": 163,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/085.jpg",
    "macros": {
      "speed": 78,
      "passing": 41,
      "physical": 65,
      "shooting": 81,
      "talent": 81,
      "defence": 78
    },
    "profileYtVideoId": "sLPuTY8pmGM",
    "matchYtVideoId": "J8M2WtRnSIo"
  },
  {
    "draftJersey": "086",
    "name": "Coral Martínez",
    "age": 20,
    "foot": "right",
    "height": 165,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/086.jpg",
    "macros": {
      "speed": 74,
      "passing": 75,
      "physical": 55,
      "shooting": 53,
      "talent": 78,
      "defence": 76
    },
    "profileYtVideoId": "9RX4kVaWMy4",
    "matchYtVideoId": "J8M2WtRnSIo"
  },
  {
    "draftJersey": "087",
    "name": "Cristina Campos",
    "age": 25,
    "foot": "right",
    "height": 171,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/087.jpg",
    "macros": {
      "speed": 84,
      "passing": 56,
      "physical": 76,
      "shooting": 70,
      "talent": 78,
      "defence": 76
    },
    "profileYtVideoId": "XG0h4tTYkKg",
    "matchYtVideoId": "J8M2WtRnSIo"
  },
  {
    "draftJersey": "088",
    "name": "Andrea Barcelona",
    "age": 22,
    "foot": "right",
    "height": 163,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/088.jpg",
    "macros": {
      "speed": 80,
      "passing": 41,
      "physical": 67,
      "shooting": 79,
      "talent": 78,
      "defence": 78
    },
    "profileYtVideoId": "XDUrUspvu7Q",
    "matchYtVideoId": "J8M2WtRnSIo"
  },
  {
    "draftJersey": "089",
    "name": "Anna Domingo",
    "age": 38,
    "foot": "right",
    "height": 172,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/089.jpg",
    "macros": {
      "speed": 71,
      "passing": 63,
      "physical": 49,
      "shooting": 58,
      "talent": 71,
      "defence": 75
    },
    "profileYtVideoId": "af_Ko3rqfqI",
    "matchYtVideoId": "drexVjTa6Kc"
  },
  {
    "draftJersey": "090",
    "name": "Anna Munné",
    "age": 26,
    "foot": "right",
    "height": 160,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/090.jpg",
    "macros": {
      "speed": 80,
      "passing": 56,
      "physical": 51,
      "shooting": 70,
      "talent": 69,
      "defence": 65
    },
    "profileYtVideoId": "K44mJLyFFeE",
    "matchYtVideoId": "j4_3pkPls_g"
  },
  {
    "draftJersey": "091",
    "name": "Anna Sampedro",
    "age": 18,
    "foot": "right",
    "height": 160,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/091.jpg",
    "macros": {
      "speed": 76,
      "passing": 65,
      "physical": 59,
      "shooting": 66,
      "talent": 73,
      "defence": 76
    },
    "profileYtVideoId": "ZTMFxpinN98",
    "matchYtVideoId": "drexVjTa6Kc"
  },
  {
    "draftJersey": "092",
    "name": "Leticia Méndez",
    "age": 31,
    "foot": "left",
    "height": 165,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/092.jpg",
    "macros": {
      "speed": 77,
      "passing": 82,
      "physical": 59,
      "shooting": 80,
      "talent": 73,
      "defence": 69
    },
    "profileYtVideoId": "k8xhUr9hEMQ",
    "matchYtVideoId": "j4_3pkPls_g"
  },
  {
    "draftJersey": "093",
    "name": "Emma Cardona",
    "age": 19,
    "foot": "right",
    "height": 162,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/093.jpg",
    "macros": {
      "speed": 78,
      "passing": 61,
      "physical": 61,
      "shooting": 90,
      "talent": 75,
      "defence": 69
    },
    "profileYtVideoId": "2kWV4BDj7so",
    "matchYtVideoId": "j4_3pkPls_g"
  },
  {
    "draftJersey": "094",
    "name": "Diana Álvarez",
    "age": 20,
    "foot": "right",
    "height": 170,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/094.jpg",
    "macros": {
      "speed": 77,
      "passing": 78,
      "physical": 48,
      "shooting": 75,
      "talent": 68,
      "defence": 69
    },
    "profileYtVideoId": "OjbIwHcIWmA",
    "matchYtVideoId": "j4_3pkPls_g"
  },
  {
    "draftJersey": "095",
    "name": "Dunia Jiménez",
    "age": 22,
    "foot": "right",
    "height": 164,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/095.jpg",
    "macros": {
      "speed": 76,
      "passing": 48,
      "physical": 49,
      "shooting": 80,
      "talent": 72,
      "defence": 64
    },
    "profileYtVideoId": "DH1fLBBjZuI",
    "matchYtVideoId": "j4_3pkPls_g"
  },
  {
    "draftJersey": "096",
    "name": "Emma Marqués",
    "age": 34,
    "foot": "right",
    "height": 161,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/096.jpg",
    "macros": {
      "speed": 81,
      "passing": 76,
      "physical": 51,
      "shooting": 80,
      "talent": 79,
      "defence": 74
    },
    "profileYtVideoId": "GsNDo2LT87I",
    "matchYtVideoId": "j4_3pkPls_g"
  },
  {
    "draftJersey": "097",
    "name": "Estela Delgado",
    "age": 22,
    "foot": "right",
    "height": 168,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/097.jpg",
    "macros": {
      "speed": 80,
      "passing": 65,
      "physical": 62,
      "shooting": 84,
      "talent": 74,
      "defence": 70
    },
    "profileYtVideoId": "_T5AvyswW5Y",
    "matchYtVideoId": "j4_3pkPls_g"
  },
  {
    "draftJersey": "098",
    "name": "Berta Vilamala",
    "age": 29,
    "foot": "right",
    "height": 152,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/098.jpg",
    "macros": {
      "speed": 84,
      "passing": 56,
      "physical": 62,
      "shooting": 67,
      "talent": 76,
      "defence": 63
    },
    "profileYtVideoId": "ppb9EkKff7A",
    "matchYtVideoId": "j4_3pkPls_g"
  },
  {
    "draftJersey": "099",
    "name": "Blanca Cros",
    "age": 26,
    "foot": "right",
    "height": 170,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/099.jpg",
    "macros": {
      "speed": 75,
      "passing": 48,
      "physical": 54,
      "shooting": 86,
      "talent": 77,
      "defence": 74
    },
    "profileYtVideoId": "eR7Y8V9d-po",
    "matchYtVideoId": "J8M2WtRnSIo"
  },
  {
    "draftJersey": 100,
    "name": "Carla Autero",
    "age": 18,
    "foot": "right",
    "height": 163,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/100.jpg",
    "macros": {
      "speed": 87,
      "passing": 75,
      "physical": 79,
      "shooting": 91,
      "talent": 81,
      "defence": 81
    },
    "profileYtVideoId": "MfTWhGnLRrU",
    "matchYtVideoId": "J8M2WtRnSIo"
  },
  {
    "draftJersey": 101,
    "name": "Estefania Navarro",
    "age": 30,
    "foot": "right",
    "height": 150,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/101.jpg",
    "macros": {
      "speed": 81,
      "passing": 45,
      "physical": 65,
      "shooting": 87,
      "talent": 78,
      "defence": 73
    },
    "profileYtVideoId": "k115n0yr_9o",
    "matchYtVideoId": "J8M2WtRnSIo"
  },
  {
    "draftJersey": 102,
    "name": "Eybis Medina",
    "age": 32,
    "foot": "right",
    "height": 160,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/102.jpg",
    "macros": {
      "speed": 78,
      "passing": 64,
      "physical": 73,
      "shooting": 89,
      "talent": 76,
      "defence": 81
    },
    "profileYtVideoId": "FbyotoJe64k",
    "matchYtVideoId": "J8M2WtRnSIo"
  },
  {
    "draftJersey": 103,
    "name": "Gema Fernández",
    "age": 21,
    "foot": "right",
    "height": 163,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/103.jpg",
    "macros": {
      "speed": 83,
      "passing": 77,
      "physical": 70,
      "shooting": 64,
      "talent": 78,
      "defence": 75
    },
    "profileYtVideoId": "nMmd0dXXjbE",
    "matchYtVideoId": "J8M2WtRnSIo"
  },
  {
    "draftJersey": 104,
    "name": "Francesca Dicu",
    "age": 29,
    "foot": "right",
    "height": 160,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/104.jpg",
    "macros": {
      "speed": 76,
      "passing": 63,
      "physical": 64,
      "shooting": 69,
      "talent": 80,
      "defence": 79
    },
    "profileYtVideoId": "m3EVv4Dr8mU",
    "matchYtVideoId": "j4_3pkPls_g"
  },
  {
    "draftJersey": 105,
    "name": "Gala Corbacho",
    "age": 17,
    "foot": "left",
    "height": 165,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/105.jpg",
    "macros": {
      "speed": 68,
      "passing": 64,
      "physical": 60,
      "shooting": 68,
      "talent": 78,
      "defence": 74
    },
    "profileYtVideoId": "iWnDCSALhOQ",
    "matchYtVideoId": "drexVjTa6Kc"
  },
  {
    "draftJersey": 106,
    "name": "Gemma Torras",
    "age": 20,
    "foot": "right",
    "height": 165,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/106.jpg",
    "macros": {
      "speed": 81,
      "passing": 44,
      "physical": 52,
      "shooting": 73,
      "talent": 76,
      "defence": 72
    },
    "profileYtVideoId": "90_ZS5u9bDU",
    "matchYtVideoId": "drexVjTa6Kc"
  },
  {
    "draftJersey": 107,
    "name": "Gisela San Emeterio",
    "age": 18,
    "foot": "right",
    "height": 166,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/107.jpg",
    "macros": {
      "speed": 74,
      "passing": 61,
      "physical": 51,
      "shooting": 82,
      "talent": 71,
      "defence": 72
    },
    "profileYtVideoId": "DYQDIeT3L2s",
    "matchYtVideoId": "drexVjTa6Kc"
  },
  {
    "draftJersey": 108,
    "name": "Clara Gay",
    "age": 22,
    "foot": "right",
    "height": 155,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/108.jpg",
    "macros": {
      "speed": 86,
      "passing": 81,
      "physical": 65,
      "shooting": 64,
      "talent": 76,
      "defence": 76
    },
    "profileYtVideoId": "O8ycI-xDc70",
    "matchYtVideoId": "YmyIZOyoQn4"
  },
  {
    "draftJersey": 109,
    "name": "Claudia Montserrat",
    "age": 20,
    "foot": "right",
    "height": 160,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/109.jpg",
    "macros": {
      "speed": 79,
      "passing": 44,
      "physical": 71,
      "shooting": 73,
      "talent": 75,
      "defence": 73
    },
    "profileYtVideoId": "6Pu5LrXsHAU",
    "matchYtVideoId": "YmyIZOyoQn4"
  },
  {
    "draftJersey": 110,
    "name": "Clàudia Sánchez",
    "age": 20,
    "foot": "right",
    "height": 162,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/110.jpg",
    "macros": {
      "speed": 79,
      "passing": 40,
      "physical": 59,
      "shooting": 70,
      "talent": 77,
      "defence": 75
    },
    "profileYtVideoId": "YoZyjj9LnU4",
    "matchYtVideoId": "YmyIZOyoQn4"
  },
  {
    "draftJersey": 111,
    "name": "Cristina Chavero",
    "age": 25,
    "foot": "right",
    "height": 156,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/111.jpg",
    "macros": {
      "speed": 84,
      "passing": 59,
      "physical": 80,
      "shooting": 78,
      "talent": 83,
      "defence": 78
    },
    "profileYtVideoId": "L4b4ngqMFOk",
    "matchYtVideoId": "YmyIZOyoQn4"
  },
  {
    "draftJersey": 112,
    "name": "Gemma Giralt",
    "age": 18,
    "foot": "right",
    "height": 170,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/112.jpg",
    "macros": {
      "speed": 68,
      "passing": 41,
      "physical": 44,
      "shooting": 83,
      "talent": 71,
      "defence": 67
    },
    "profileYtVideoId": "jk1INOtwyz0",
    "matchYtVideoId": "j4_3pkPls_g"
  },
  {
    "draftJersey": 113,
    "name": "Georgina Casals",
    "age": 28,
    "foot": "right",
    "height": 164,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/113.jpg",
    "macros": {
      "speed": 79,
      "passing": 56,
      "physical": 61,
      "shooting": 84,
      "talent": 78,
      "defence": 75
    },
    "profileYtVideoId": "QZO1I1l6mzI",
    "matchYtVideoId": "YmyIZOyoQn4"
  },
  {
    "draftJersey": 114,
    "name": "Hannah Oxley",
    "age": 21,
    "foot": "right",
    "height": 155,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/114.jpg",
    "macros": {
      "speed": 77,
      "passing": 74,
      "physical": 38,
      "shooting": 64,
      "talent": 72,
      "defence": 71
    },
    "profileYtVideoId": "NrVka_vPZJk",
    "matchYtVideoId": "YmyIZOyoQn4"
  },
  {
    "draftJersey": 115,
    "name": "Irina Godó",
    "age": 24,
    "foot": "right",
    "height": 168,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/115.jpg",
    "macros": {
      "speed": 77,
      "passing": 60,
      "physical": 65,
      "shooting": 76,
      "talent": 73,
      "defence": 74
    },
    "profileYtVideoId": "vyyOVVYsED4",
    "matchYtVideoId": "YmyIZOyoQn4"
  },
  {
    "draftJersey": 116,
    "name": "Iris Domínguez",
    "age": 34,
    "foot": "right",
    "height": 156,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/116.jpg",
    "macros": {
      "speed": 76,
      "passing": 59,
      "physical": 53,
      "shooting": 91,
      "talent": 82,
      "defence": 77
    },
    "profileYtVideoId": "PQu3NIqfvAg",
    "matchYtVideoId": "YmyIZOyoQn4"
  },
  {
    "draftJersey": 117,
    "name": "Jessica García",
    "age": 30,
    "foot": "right",
    "height": 161,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/117.jpg",
    "macros": {
      "speed": 75,
      "passing": 44,
      "physical": 64,
      "shooting": 89,
      "talent": 79,
      "defence": 81
    },
    "profileYtVideoId": "KqkFFz67T1k",
    "matchYtVideoId": "YmyIZOyoQn4"
  },
  {
    "draftJersey": 118,
    "name": "Judit Ferrari",
    "age": 28,
    "foot": "right",
    "height": 168,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/118.jpg",
    "macros": {
      "speed": 76,
      "passing": 62,
      "physical": 62,
      "shooting": 68,
      "talent": 79,
      "defence": 66
    },
    "profileYtVideoId": "RjgO8RRyG7o",
    "matchYtVideoId": "8xS-j-QCAmo"
  },
  {
    "draftJersey": 119,
    "name": "Cristina Martín",
    "age": 18,
    "foot": "left",
    "height": 165,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/119.jpg",
    "macros": {
      "speed": 75,
      "passing": 57,
      "physical": 52,
      "shooting": 76,
      "talent": 79,
      "defence": 72
    },
    "profileYtVideoId": "IGNl_FXhLM4",
    "matchYtVideoId": "YmyIZOyoQn4"
  },
  {
    "draftJersey": 120,
    "name": "Daniela Salvat",
    "age": 19,
    "foot": "right",
    "height": 166,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/120.jpg",
    "macros": {
      "speed": 76,
      "passing": 46,
      "physical": 59,
      "shooting": 68,
      "talent": 73,
      "defence": 81
    },
    "profileYtVideoId": "LkOy9HqBIy0",
    "matchYtVideoId": "drexVjTa6Kc"
  },
  {
    "draftJersey": 121,
    "name": "Dayanna Aquino",
    "age": 28,
    "foot": "left",
    "height": 169,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/121.jpg",
    "macros": {
      "speed": 79,
      "passing": 59,
      "physical": 51,
      "shooting": 81,
      "talent": 79,
      "defence": 63
    },
    "profileYtVideoId": "SIjVvBQMNF0",
    "matchYtVideoId": "drexVjTa6Kc"
  },
  {
    "draftJersey": 122,
    "name": "Élida Tortosa",
    "age": 21,
    "foot": "left",
    "height": 170,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/122.jpg",
    "macros": {
      "speed": 75,
      "passing": 62,
      "physical": 60,
      "shooting": 77,
      "talent": 71,
      "defence": 75
    },
    "profileYtVideoId": "fsL5EdJ1flk",
    "matchYtVideoId": "drexVjTa6Kc"
  },
  {
    "draftJersey": 123,
    "name": "Paula Manso",
    "age": 22,
    "foot": "right",
    "height": 160,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/123.jpg",
    "macros": {
      "speed": 78,
      "passing": 65,
      "physical": 52,
      "shooting": 68,
      "talent": 78,
      "defence": 73
    },
    "profileYtVideoId": "eV1I5m8fO7c",
    "matchYtVideoId": "AdiKCIODW8k"
  },
  {
    "draftJersey": 124,
    "name": "Irene Griso",
    "age": 20,
    "foot": "right",
    "height": 176,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/124.jpg",
    "macros": {
      "speed": 74,
      "passing": 61,
      "physical": 51,
      "shooting": 69,
      "talent": 75,
      "defence": 76
    },
    "profileYtVideoId": "-ToVMF3wWdg",
    "matchYtVideoId": "drexVjTa6Kc"
  },
  {
    "draftJersey": 125,
    "name": "Isabel Margalef",
    "age": 23,
    "foot": "right",
    "height": 170,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/125.jpg",
    "macros": {
      "speed": 79,
      "passing": 49,
      "physical": 62,
      "shooting": 77,
      "talent": 74,
      "defence": 69
    },
    "profileYtVideoId": "QGakAengybw",
    "matchYtVideoId": "drexVjTa6Kc"
  },
  {
    "draftJersey": 127,
    "name": "Kautar Azdaou",
    "age": 28,
    "foot": "right",
    "height": 160,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/127.jpg",
    "macros": {
      "speed": 77,
      "passing": 43,
      "physical": 65,
      "shooting": 82,
      "talent": 82,
      "defence": 79
    },
    "profileYtVideoId": "NzjdTEYdTTE",
    "matchYtVideoId": "DfatJdKAVnk"
  },
  {
    "draftJersey": 129,
    "name": "Andrea Luna",
    "age": 20,
    "foot": "right",
    "height": 0,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/129.jpg",
    "macros": {
      "speed": 81,
      "passing": 77,
      "physical": 77,
      "shooting": 79,
      "talent": 82,
      "defence": 82
    },
    "profileYtVideoId": "I7g44x_ghiw",
    "matchYtVideoId": "DfatJdKAVnk"
  },
  {
    "draftJersey": 130,
    "name": "Ester Sánchez",
    "age": 30,
    "foot": "right",
    "height": 169,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/130.jpg",
    "macros": {
      "speed": 78,
      "passing": 48,
      "physical": 49,
      "shooting": 81,
      "talent": 74,
      "defence": 74
    },
    "profileYtVideoId": "tv1RuXC0sOk",
    "matchYtVideoId": "8ZKvX_bkk3Y"
  },
  {
    "draftJersey": 131,
    "name": "Gabriela Garcia",
    "age": 18,
    "foot": "right",
    "height": 170,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/131.jpg",
    "macros": {
      "speed": 79,
      "passing": 49,
      "physical": 53,
      "shooting": 75,
      "talent": 77,
      "defence": 79
    },
    "profileYtVideoId": "n7x8OCg-YhM",
    "matchYtVideoId": "DfatJdKAVnk"
  },
  {
    "draftJersey": 132,
    "name": "Gabriela Morales",
    "age": 27,
    "foot": "right",
    "height": 165,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/132.jpg",
    "macros": {
      "speed": 79,
      "passing": 56,
      "physical": 57,
      "shooting": 78,
      "talent": 77,
      "defence": 72
    },
    "profileYtVideoId": "kBOSdBzFeGw",
    "matchYtVideoId": "zmniE3Hnkos"
  },
  {
    "draftJersey": 133,
    "name": "Judith Saubi",
    "age": 24,
    "foot": "right",
    "height": 165,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/133.jpg",
    "macros": {
      "speed": 80,
      "passing": 64,
      "physical": 51,
      "shooting": 91,
      "talent": 72,
      "defence": 75
    },
    "profileYtVideoId": "SoerQjZU168",
    "matchYtVideoId": "fDmA44ZmOnM"
  },
  {
    "draftJersey": 134,
    "name": "Julia Sanz",
    "age": 25,
    "foot": "right",
    "height": 167,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/134.jpg",
    "macros": {
      "speed": 80,
      "passing": 82,
      "physical": 52,
      "shooting": 65,
      "talent": 70,
      "defence": 72
    },
    "profileYtVideoId": "N2cNq_GCGYU",
    "matchYtVideoId": "zmniE3Hnkos"
  },
  {
    "draftJersey": 135,
    "name": "Júlia Tomàs",
    "age": 23,
    "foot": "right",
    "height": 159,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/135.jpg",
    "macros": {
      "speed": 84,
      "passing": 80,
      "physical": 61,
      "shooting": 56,
      "talent": 72,
      "defence": 74
    },
    "profileYtVideoId": "uu4cxAS-gKg",
    "matchYtVideoId": "zmniE3Hnkos"
  },
  {
    "draftJersey": 136,
    "name": "Laura Marcet",
    "age": 24,
    "foot": "left",
    "height": 170,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/136.jpg",
    "macros": {
      "speed": 70,
      "passing": 78,
      "physical": 51,
      "shooting": 82,
      "talent": 85,
      "defence": 74
    },
    "profileYtVideoId": "q3kYr1x9gHA",
    "matchYtVideoId": "fDmA44ZmOnM"
  },
  {
    "draftJersey": 137,
    "name": "Laura Ortiz",
    "age": 29,
    "foot": "right",
    "height": 164,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/137.jpg",
    "macros": {
      "speed": 73,
      "passing": 56,
      "physical": 59,
      "shooting": 76,
      "talent": 77,
      "defence": 78
    },
    "profileYtVideoId": "lcHZF5Ra2pE",
    "matchYtVideoId": "zmniE3Hnkos"
  },
  {
    "draftJersey": 138,
    "name": "Leticia Viñole",
    "age": 34,
    "foot": "right",
    "height": 154,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/138.jpg",
    "macros": {
      "speed": 76,
      "passing": 46,
      "physical": 51,
      "shooting": 83,
      "talent": 72,
      "defence": 69
    },
    "profileYtVideoId": "IR9q5xnSc9s",
    "matchYtVideoId": "zmniE3Hnkos"
  },
  {
    "draftJersey": 139,
    "name": "Lidia Rabassa",
    "age": 19,
    "foot": "right",
    "height": 166,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/139.jpg",
    "macros": {
      "speed": 80,
      "passing": 58,
      "physical": 54,
      "shooting": 73,
      "talent": 76,
      "defence": 69
    },
    "profileYtVideoId": "Sm7Mw3RaxUM",
    "matchYtVideoId": "zmniE3Hnkos"
  },
  {
    "draftJersey": 140,
    "name": "Marta Farreras",
    "age": 19,
    "foot": "right",
    "height": 168,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/140.jpg",
    "macros": {
      "speed": 77,
      "passing": 47,
      "physical": 55,
      "shooting": 69,
      "talent": 78,
      "defence": 83
    },
    "profileYtVideoId": "UVZOc73EMs8",
    "matchYtVideoId": "8ZKvX_bkk3Y"
  },
  {
    "draftJersey": 141,
    "name": "Gemma Vilariño",
    "age": 28,
    "foot": "right",
    "height": 148,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/141.jpg",
    "macros": {
      "speed": 86,
      "passing": 63,
      "physical": 59,
      "shooting": 72,
      "talent": 80,
      "defence": 80
    },
    "profileYtVideoId": "unZmvvKdCNk",
    "matchYtVideoId": "fDmA44ZmOnM"
  },
  {
    "draftJersey": 142,
    "name": "Geraldine Gama",
    "age": 22,
    "foot": "right",
    "height": 150,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/142.jpg",
    "macros": {
      "speed": 83,
      "passing": 62,
      "physical": 55,
      "shooting": 78,
      "talent": 74,
      "defence": 66
    },
    "profileYtVideoId": "Cs53w3swMjU",
    "matchYtVideoId": "zmniE3Hnkos"
  },
  {
    "draftJersey": 144,
    "name": "Kiara Ribas",
    "age": 22,
    "foot": "right",
    "height": 169,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/144.jpg",
    "macros": {
      "speed": 70,
      "passing": 78,
      "physical": 53,
      "shooting": 79,
      "talent": 78,
      "defence": 76
    },
    "profileYtVideoId": "mEM1wWUuc1k",
    "matchYtVideoId": "8ZKvX_bkk3Y"
  },
  {
    "draftJersey": 145,
    "name": "Laia Cámara",
    "age": 17,
    "foot": "right",
    "height": 170,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/145.jpg",
    "macros": {
      "speed": 81,
      "passing": 42,
      "physical": 63,
      "shooting": 75,
      "talent": 79,
      "defence": 79
    },
    "profileYtVideoId": "qxt3g2XxUm0",
    "matchYtVideoId": "8ZKvX_bkk3Y"
  },
  {
    "draftJersey": 146,
    "name": "Laia Sales",
    "age": 20,
    "foot": "right",
    "height": 164,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/146.jpg",
    "macros": {
      "speed": 84,
      "passing": 56,
      "physical": 57,
      "shooting": 72,
      "talent": 78,
      "defence": 75
    },
    "profileYtVideoId": "vNRmfW11fVY",
    "matchYtVideoId": "DfatJdKAVnk"
  },
  {
    "draftJersey": 148,
    "name": "Lucia Gimeno",
    "age": 17,
    "foot": "right",
    "height": 157,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/148.jpg",
    "macros": {
      "speed": 73,
      "passing": 60,
      "physical": 38,
      "shooting": 56,
      "talent": 73,
      "defence": 76
    },
    "profileYtVideoId": "FDwRVOBWV0g",
    "matchYtVideoId": "zmniE3Hnkos"
  },
  {
    "draftJersey": 149,
    "name": "Mar Serracanta",
    "age": 22,
    "foot": "left",
    "height": 164,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/149.jpg",
    "macros": {
      "speed": 80,
      "passing": 43,
      "physical": 61,
      "shooting": 67,
      "talent": 80,
      "defence": 79
    },
    "profileYtVideoId": "klUsWXP-wJM",
    "matchYtVideoId": "zmniE3Hnkos"
  },
  {
    "draftJersey": 150,
    "name": "María Álvarez",
    "age": 27,
    "foot": "right",
    "height": 165,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/150.jpg",
    "macros": {
      "speed": 74,
      "passing": 81,
      "physical": 55,
      "shooting": 75,
      "talent": 74,
      "defence": 73
    },
    "profileYtVideoId": "FoMPo9eMHxo",
    "matchYtVideoId": "fDmA44ZmOnM"
  },
  {
    "draftJersey": 151,
    "name": "Maria Llobet",
    "age": 26,
    "foot": "right",
    "height": 155,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/151.jpg",
    "macros": {
      "speed": 80,
      "passing": 76,
      "physical": 73,
      "shooting": 67,
      "talent": 74,
      "defence": 77
    },
    "profileYtVideoId": "X0qjDyhajcY",
    "matchYtVideoId": "fDmA44ZmOnM"
  },
  {
    "draftJersey": 152,
    "name": "Julia Cerdán",
    "age": 23,
    "foot": "right",
    "height": 174,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/152.jpg",
    "macros": {
      "speed": 83,
      "passing": 82,
      "physical": 52,
      "shooting": 71,
      "talent": 81,
      "defence": 73
    },
    "profileYtVideoId": "YdD9oJLf3h4",
    "matchYtVideoId": "8ZKvX_bkk3Y"
  },
  {
    "draftJersey": 153,
    "name": "Laia Atanasio",
    "age": 21,
    "foot": "right",
    "height": 161,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/153.jpg",
    "macros": {
      "speed": 82,
      "passing": 62,
      "physical": 61,
      "shooting": 87,
      "talent": 75,
      "defence": 75
    },
    "profileYtVideoId": "OgFpZ2QEWNA",
    "matchYtVideoId": "fDmA44ZmOnM"
  },
  {
    "draftJersey": 154,
    "name": "Laia Pujades",
    "age": 25,
    "foot": "right",
    "height": 175,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/154.jpg",
    "macros": {
      "speed": 75,
      "passing": 47,
      "physical": 58,
      "shooting": 75,
      "talent": 77,
      "defence": 73
    },
    "profileYtVideoId": "uU8Pp2OR5x8",
    "matchYtVideoId": "8ZKvX_bkk3Y"
  },
  {
    "draftJersey": 155,
    "name": "Laura Bustos",
    "age": 27,
    "foot": "right",
    "height": 167,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/155.jpg",
    "macros": {
      "speed": 73,
      "passing": 81,
      "physical": 53,
      "shooting": 85,
      "talent": 79,
      "defence": 80
    },
    "profileYtVideoId": "SkoEQuv-9Rg",
    "matchYtVideoId": "DfatJdKAVnk"
  },
  {
    "draftJersey": 156,
    "name": "Laura Fernández",
    "age": 20,
    "foot": "right",
    "height": 168,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/156.jpg",
    "macros": {
      "speed": 79,
      "passing": 63,
      "physical": 55,
      "shooting": 65,
      "talent": 78,
      "defence": 74
    },
    "profileYtVideoId": "20xUuLdBeY8",
    "matchYtVideoId": "DfatJdKAVnk"
  },
  {
    "draftJersey": 157,
    "name": "Laura Ribas",
    "age": 22,
    "foot": "right",
    "height": 174,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/157.jpg",
    "macros": {
      "speed": 89,
      "passing": 57,
      "physical": 67,
      "shooting": 76,
      "talent": 80,
      "defence": 84
    },
    "profileYtVideoId": "oRaNqc5Xm3Y",
    "matchYtVideoId": "8ZKvX_bkk3Y"
  },
  {
    "draftJersey": 158,
    "name": "Maria Vallès",
    "age": 26,
    "foot": "right",
    "height": 163,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/158.jpg",
    "macros": {
      "speed": 71,
      "passing": 61,
      "physical": 59,
      "shooting": 83,
      "talent": 78,
      "defence": 79
    },
    "profileYtVideoId": "dK9NEZyuQOQ",
    "matchYtVideoId": "DfatJdKAVnk"
  },
  {
    "draftJersey": 159,
    "name": "Marina Flor",
    "age": 25,
    "foot": "right",
    "height": 163,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/159.jpg",
    "macros": {
      "speed": 84,
      "passing": 61,
      "physical": 60,
      "shooting": 81,
      "talent": 75,
      "defence": 73
    },
    "profileYtVideoId": "AHB73yIdwhU",
    "matchYtVideoId": "DfatJdKAVnk"
  },
  {
    "draftJersey": 160,
    "name": "Marina Gama",
    "age": 26,
    "foot": "left",
    "height": 163,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/160.jpg",
    "macros": {
      "speed": 79,
      "passing": 61,
      "physical": 64,
      "shooting": 83,
      "talent": 76,
      "defence": 77
    },
    "profileYtVideoId": "P9yRjhtkgnk",
    "matchYtVideoId": "DfatJdKAVnk"
  },
  {
    "draftJersey": 161,
    "name": "Laia Torres",
    "age": 21,
    "foot": "right",
    "height": 166,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/161.jpg",
    "macros": {
      "speed": 82,
      "passing": 78,
      "physical": 69,
      "shooting": 60,
      "talent": 76,
      "defence": 71
    },
    "profileYtVideoId": "fFQ2kLEx1Yg",
    "matchYtVideoId": "DfatJdKAVnk"
  },
  {
    "draftJersey": 162,
    "name": "Lara Rodríguez",
    "age": 16,
    "foot": "right",
    "height": 164,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/162.jpg",
    "macros": {
      "speed": 80,
      "passing": 47,
      "physical": 72,
      "shooting": 55,
      "talent": 74,
      "defence": 75
    },
    "profileYtVideoId": "g-b2-T1axhg",
    "matchYtVideoId": "8ZKvX_bkk3Y"
  },
  {
    "draftJersey": 163,
    "name": "Leiriane Aguiar",
    "age": 27,
    "foot": "right",
    "height": 163,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/163.jpg",
    "macros": {
      "speed": 77,
      "passing": 59,
      "physical": 50,
      "shooting": 83,
      "talent": 71,
      "defence": 69
    },
    "profileYtVideoId": "kd45eWAp6zg",
    "matchYtVideoId": "8ZKvX_bkk3Y"
  },
  {
    "draftJersey": 164,
    "name": "Luisa Vertel",
    "age": 22,
    "foot": "right",
    "height": 167,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/164.jpg",
    "macros": {
      "speed": 81,
      "passing": 64,
      "physical": 58,
      "shooting": 76,
      "talent": 77,
      "defence": 75
    },
    "profileYtVideoId": "eaShaZnjxu8",
    "matchYtVideoId": "fDmA44ZmOnM"
  },
  {
    "draftJersey": 165,
    "name": "Cristina Ballesteros",
    "age": 31,
    "foot": "right",
    "height": 168,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/165.jpg",
    "macros": {
      "speed": 77,
      "passing": 49,
      "physical": 51,
      "shooting": 65,
      "talent": 72,
      "defence": 70
    },
    "profileYtVideoId": "NgKcB0R3KvY",
    "matchYtVideoId": "fDmA44ZmOnM"
  },
  {
    "draftJersey": 166,
    "name": "María Flores",
    "age": 21,
    "foot": "left",
    "height": 170,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/166.jpg",
    "macros": {
      "speed": 79,
      "passing": 46,
      "physical": 59,
      "shooting": 91,
      "talent": 75,
      "defence": 76
    },
    "profileYtVideoId": "OgYcwrPx0Ws",
    "matchYtVideoId": "zmniE3Hnkos"
  },
  {
    "draftJersey": 167,
    "name": "Maria López",
    "age": 29,
    "foot": "right",
    "height": 165,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/167.jpg",
    "macros": {
      "speed": 67,
      "passing": 64,
      "physical": 27,
      "shooting": 89,
      "talent": 72,
      "defence": 70
    },
    "profileYtVideoId": "0WB-Q85YA9U",
    "matchYtVideoId": "fDmA44ZmOnM"
  },
  {
    "draftJersey": 168,
    "name": "Aina Llovera",
    "age": 24,
    "foot": "right",
    "height": 160,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/168.jpg",
    "macros": {
      "speed": 78,
      "passing": 59,
      "physical": 56,
      "shooting": 57,
      "talent": 80,
      "defence": 73
    },
    "profileYtVideoId": "8jsEt8uWQ28",
    "matchYtVideoId": "NWPtRbiUfSk"
  },
  {
    "draftJersey": 169,
    "name": "Mariona Pujol",
    "age": 21,
    "foot": "left",
    "height": 169,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/169.jpg",
    "macros": {
      "speed": 82,
      "passing": 40,
      "physical": 62,
      "shooting": 53,
      "talent": 77,
      "defence": 78
    },
    "profileYtVideoId": "UogxX_bilwY",
    "matchYtVideoId": "n71D_DJOJpk"
  },
  {
    "draftJersey": 170,
    "name": "Marta Enrich",
    "age": 32,
    "foot": "right",
    "height": 161,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/170.jpg",
    "macros": {
      "speed": 79,
      "passing": 64,
      "physical": 65,
      "shooting": 62,
      "talent": 77,
      "defence": 77
    },
    "profileYtVideoId": "o9ORlIPbDbo",
    "matchYtVideoId": "NWPtRbiUfSk"
  },
  {
    "draftJersey": 171,
    "name": "Alba Vidal",
    "age": 23,
    "foot": "right",
    "height": 168,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/171.jpg",
    "macros": {
      "speed": 79,
      "passing": 57,
      "physical": 44,
      "shooting": 61,
      "talent": 69,
      "defence": 69
    },
    "profileYtVideoId": "jbKLZhr4T6w",
    "matchYtVideoId": "n71D_DJOJpk"
  },
  {
    "draftJersey": 172,
    "name": "Maria de Fulgencio",
    "age": 21,
    "foot": "right",
    "height": 178,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/172.jpg",
    "macros": {
      "speed": 73,
      "passing": 48,
      "physical": 49,
      "shooting": 76,
      "talent": 79,
      "defence": 73
    },
    "profileYtVideoId": "QoTCq0Klsjc",
    "matchYtVideoId": "n71D_DJOJpk"
  },
  {
    "draftJersey": 173,
    "name": "Maria Farreras",
    "age": 35,
    "foot": "right",
    "height": 167,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/173.jpg",
    "macros": {
      "speed": 79,
      "passing": 40,
      "physical": 61,
      "shooting": 78,
      "talent": 80,
      "defence": 74
    },
    "profileYtVideoId": "AybXZBnrdyU",
    "matchYtVideoId": "C7gCiKy3TJ4"
  },
  {
    "draftJersey": 175,
    "name": "Marina Peya",
    "age": 24,
    "foot": "right",
    "height": 163,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/175.jpg",
    "macros": {
      "speed": 72,
      "passing": 74,
      "physical": 52,
      "shooting": 87,
      "talent": 75,
      "defence": 73
    },
    "profileYtVideoId": "w-yN9QPYewQ",
    "matchYtVideoId": "5lo1L-VtIGw"
  },
  {
    "draftJersey": 176,
    "name": "Martina Rojo",
    "age": 17,
    "foot": "right",
    "height": 168,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/176.jpg",
    "macros": {
      "speed": 81,
      "passing": 57,
      "physical": 66,
      "shooting": 65,
      "talent": 80,
      "defence": 76
    },
    "profileYtVideoId": "OG1filE4WDc",
    "matchYtVideoId": "C7gCiKy3TJ4"
  },
  {
    "draftJersey": 177,
    "name": "Mireia Alejandre",
    "age": 22,
    "foot": "right",
    "height": 164,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/177.jpg",
    "macros": {
      "speed": 78,
      "passing": 60,
      "physical": 62,
      "shooting": 87,
      "talent": 75,
      "defence": 70
    },
    "profileYtVideoId": "7GjtaKfye4s",
    "matchYtVideoId": "C7gCiKy3TJ4"
  },
  {
    "draftJersey": 178,
    "name": "Marta Vilar",
    "age": 24,
    "foot": "right",
    "height": 167,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/178.jpg",
    "macros": {
      "speed": 82,
      "passing": 81,
      "physical": 63,
      "shooting": 61,
      "talent": 77,
      "defence": 71
    },
    "profileYtVideoId": "EyFQhKXUkvI",
    "matchYtVideoId": "C7gCiKy3TJ4"
  },
  {
    "draftJersey": 179,
    "name": "Martina Roig",
    "age": 17,
    "foot": "right",
    "height": 170,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/179.jpg",
    "macros": {
      "speed": 84,
      "passing": 79,
      "physical": 52,
      "shooting": 74,
      "talent": 75,
      "defence": 75
    },
    "profileYtVideoId": "fKQKlvum7I8",
    "matchYtVideoId": "5lo1L-VtIGw"
  },
  {
    "draftJersey": 180,
    "name": "Mireia Lluch",
    "age": 30,
    "foot": "left",
    "height": 167,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/180.jpg",
    "macros": {
      "speed": 78,
      "passing": 82,
      "physical": 59,
      "shooting": 74,
      "talent": 76,
      "defence": 76
    },
    "profileYtVideoId": "S1H4zifCL3E",
    "matchYtVideoId": "C7gCiKy3TJ4"
  },
  {
    "draftJersey": 181,
    "name": "Monica Brañas",
    "age": 31,
    "foot": "right",
    "height": 166,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/181.jpg",
    "macros": {
      "speed": 72,
      "passing": 80,
      "physical": 57,
      "shooting": 72,
      "talent": 77,
      "defence": 75
    },
    "profileYtVideoId": "JMCmUF6kn0I",
    "matchYtVideoId": "C7gCiKy3TJ4"
  },
  {
    "draftJersey": 182,
    "name": "Marina Batalla",
    "age": 35,
    "foot": "right",
    "height": 165,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/182.jpg",
    "macros": {
      "speed": 71,
      "passing": 40,
      "physical": 37,
      "shooting": 57,
      "talent": 71,
      "defence": 67
    },
    "profileYtVideoId": "HNAMKAmo2c8",
    "matchYtVideoId": "5lo1L-VtIGw"
  },
  {
    "draftJersey": 183,
    "name": "Mireia Boix",
    "age": 23,
    "foot": "right",
    "height": 168,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/183.jpg",
    "macros": {
      "speed": 81,
      "passing": 75,
      "physical": 68,
      "shooting": 74,
      "talent": 76,
      "defence": 73
    },
    "profileYtVideoId": "ACRtjQU3-aQ",
    "matchYtVideoId": "NWPtRbiUfSk"
  },
  {
    "draftJersey": 184,
    "name": "Marina Saladich",
    "age": 26,
    "foot": "right",
    "height": 165,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/184.jpg",
    "macros": {
      "speed": 77,
      "passing": 62,
      "physical": 55,
      "shooting": 79,
      "talent": 77,
      "defence": 72
    },
    "profileYtVideoId": "C3QU2evSDfc",
    "matchYtVideoId": "NWPtRbiUfSk"
  },
  {
    "draftJersey": 185,
    "name": "Mireia Andrés",
    "age": 19,
    "foot": "right",
    "height": 163,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/185.jpg",
    "macros": {
      "speed": 82,
      "passing": 62,
      "physical": 55,
      "shooting": 76,
      "talent": 74,
      "defence": 77
    },
    "profileYtVideoId": "Q2zetv1QD6k",
    "matchYtVideoId": "NWPtRbiUfSk"
  },
  {
    "draftJersey": 186,
    "name": "Mónica Morote",
    "age": 23,
    "foot": "right",
    "height": 176,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/186.jpg",
    "macros": {
      "speed": 76,
      "passing": 56,
      "physical": 53,
      "shooting": 67,
      "talent": 79,
      "defence": 76
    },
    "profileYtVideoId": "JDDflL8hzts",
    "matchYtVideoId": "n71D_DJOJpk"
  },
  {
    "draftJersey": 187,
    "name": "Nacha Garrote",
    "age": 28,
    "foot": "right",
    "height": 160,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/187.jpg",
    "macros": {
      "speed": 81,
      "passing": 65,
      "physical": 45,
      "shooting": 81,
      "talent": 73,
      "defence": 79
    },
    "profileYtVideoId": "hK7nZRtPOJo",
    "matchYtVideoId": "n71D_DJOJpk"
  },
  {
    "draftJersey": 189,
    "name": "Neus Motoso",
    "age": 31,
    "foot": "right",
    "height": 160,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/189.jpg",
    "macros": {
      "speed": 78,
      "passing": 77,
      "physical": 48,
      "shooting": 81,
      "talent": 74,
      "defence": 70
    },
    "profileYtVideoId": "rc1MJvMpzB4",
    "matchYtVideoId": "C7gCiKy3TJ4"
  },
  {
    "draftJersey": 190,
    "name": "Nicole Rubio",
    "age": 24,
    "foot": "right",
    "height": 160,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/190.jpg",
    "macros": {
      "speed": 79,
      "passing": 40,
      "physical": 59,
      "shooting": 81,
      "talent": 74,
      "defence": 69
    },
    "profileYtVideoId": "tGi3q5mJT7o",
    "matchYtVideoId": "5lo1L-VtIGw"
  },
  {
    "draftJersey": 191,
    "name": "Naiara Caballero",
    "age": 24,
    "foot": "right",
    "height": 165,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/191.jpg",
    "macros": {
      "speed": 73,
      "passing": 77,
      "physical": 57,
      "shooting": 90,
      "talent": 74,
      "defence": 75
    },
    "profileYtVideoId": "WtTg4lj0n9k",
    "matchYtVideoId": "5lo1L-VtIGw"
  },
  {
    "draftJersey": 192,
    "name": "Nuria Mallada",
    "age": 31,
    "foot": "right",
    "height": 162,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/192.jpg",
    "macros": {
      "speed": 77,
      "passing": 48,
      "physical": 59,
      "shooting": 83,
      "talent": 74,
      "defence": 69
    },
    "profileYtVideoId": "UbFBbzWC590",
    "matchYtVideoId": "C7gCiKy3TJ4"
  },
  {
    "draftJersey": 193,
    "name": "Paloma Cantillo",
    "age": 16,
    "foot": "right",
    "height": 170,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/193.jpg",
    "macros": {
      "speed": 80,
      "passing": 57,
      "physical": 65,
      "shooting": 75,
      "talent": 80,
      "defence": 84
    },
    "profileYtVideoId": "NSLf7oDRS-U",
    "matchYtVideoId": "NWPtRbiUfSk"
  },
  {
    "draftJersey": 194,
    "name": "Patricia Carballo",
    "age": 27,
    "foot": "right",
    "height": 167,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/194.jpg",
    "macros": {
      "speed": 78,
      "passing": 47,
      "physical": 67,
      "shooting": 59,
      "talent": 81,
      "defence": 82
    },
    "profileYtVideoId": "aHas_PpqrxI",
    "matchYtVideoId": "n71D_DJOJpk"
  },
  {
    "draftJersey": 195,
    "name": "Neus Juncà",
    "age": 22,
    "foot": "left",
    "height": 166,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/195.jpg",
    "macros": {
      "speed": 79,
      "passing": 62,
      "physical": 64,
      "shooting": 73,
      "talent": 77,
      "defence": 76
    },
    "profileYtVideoId": "5JKuoQiKJxk",
    "matchYtVideoId": "NWPtRbiUfSk"
  },
  {
    "draftJersey": 196,
    "name": "Noemí Acharkouk",
    "age": 28,
    "foot": "right",
    "height": 158,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/196.jpg",
    "macros": {
      "speed": 76,
      "passing": 49,
      "physical": 67,
      "shooting": 53,
      "talent": 76,
      "defence": 76
    },
    "profileYtVideoId": "ETzr_IZeLyI",
    "matchYtVideoId": "n71D_DJOJpk"
  },
  {
    "draftJersey": 197,
    "name": "Patricia Muga",
    "age": 17,
    "foot": "right",
    "height": 168,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/197.jpg",
    "macros": {
      "speed": 80,
      "passing": 73,
      "physical": 63,
      "shooting": 76,
      "talent": 72,
      "defence": 78
    },
    "profileYtVideoId": "W62O0yTM9Po",
    "matchYtVideoId": "NWPtRbiUfSk"
  },
  {
    "draftJersey": 198,
    "name": "Noa Barber",
    "age": 19,
    "foot": "right",
    "height": 165,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/198.jpg",
    "macros": {
      "speed": 83,
      "passing": 40,
      "physical": 65,
      "shooting": 63,
      "talent": 79,
      "defence": 79
    },
    "profileYtVideoId": "fYyp7bAR7xI",
    "matchYtVideoId": "NWPtRbiUfSk"
  },
  {
    "draftJersey": 199,
    "name": "Nuria Cervera",
    "age": 23,
    "foot": "right",
    "height": 167,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/199.jpg",
    "macros": {
      "speed": 74,
      "passing": 46,
      "physical": 49,
      "shooting": 81,
      "talent": 79,
      "defence": 76
    },
    "profileYtVideoId": "s0tX34fS1vg",
    "matchYtVideoId": "NWPtRbiUfSk"
  },
  {
    "draftJersey": 200,
    "name": "Núria Llop",
    "age": 31,
    "foot": "right",
    "height": 163,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/200.jpg",
    "macros": {
      "speed": 78,
      "passing": 58,
      "physical": 74,
      "shooting": 80,
      "talent": 84,
      "defence": 78
    },
    "profileYtVideoId": "Wt0Auwbw-48",
    "matchYtVideoId": "n71D_DJOJpk"
  },
  {
    "draftJersey": 201,
    "name": "Ona Aldea",
    "age": 21,
    "foot": "right",
    "height": 165,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/201.jpg",
    "macros": {
      "speed": 77,
      "passing": 74,
      "physical": 65,
      "shooting": 62,
      "talent": 80,
      "defence": 76
    },
    "profileYtVideoId": "vijuBHnYD48",
    "matchYtVideoId": "n71D_DJOJpk"
  },
  {
    "draftJersey": 202,
    "name": "Paula Moreno",
    "age": 21,
    "foot": "right",
    "height": 171,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/202.jpg",
    "macros": {
      "speed": 81,
      "passing": 74,
      "physical": 53,
      "shooting": 80,
      "talent": 76,
      "defence": 75
    },
    "profileYtVideoId": "XOfJEFnHXH8",
    "matchYtVideoId": "n71D_DJOJpk"
  },
  {
    "draftJersey": 203,
    "name": "Salomé Navalón",
    "age": 31,
    "foot": "right",
    "height": 160,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/203.jpg",
    "macros": {
      "speed": 79,
      "passing": 60,
      "physical": 63,
      "shooting": 89,
      "talent": 74,
      "defence": 76
    },
    "profileYtVideoId": "_f3Mvy0H3Og",
    "matchYtVideoId": "C7gCiKy3TJ4"
  },
  {
    "draftJersey": 204,
    "name": "Sandra Alamán",
    "age": 20,
    "foot": "right",
    "height": 157,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/204.jpg",
    "macros": {
      "speed": 68,
      "passing": 80,
      "physical": 51,
      "shooting": 84,
      "talent": 74,
      "defence": 67
    },
    "profileYtVideoId": "XgF4rXE3P18",
    "matchYtVideoId": "5lo1L-VtIGw"
  },
  {
    "draftJersey": 205,
    "name": "Paula Fernández",
    "age": 20,
    "foot": "right",
    "height": 171,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/205.jpg",
    "macros": {
      "speed": 81,
      "passing": 74,
      "physical": 50,
      "shooting": 88,
      "talent": 75,
      "defence": 75
    },
    "profileYtVideoId": "I5D0T8Fil40",
    "matchYtVideoId": "C7gCiKy3TJ4"
  },
  {
    "draftJersey": 206,
    "name": "Paula Núñez",
    "age": 27,
    "foot": "left",
    "height": 164,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/206.jpg",
    "macros": {
      "speed": 80,
      "passing": 75,
      "physical": 68,
      "shooting": 77,
      "talent": 81,
      "defence": 74
    },
    "profileYtVideoId": "k_a3QmFUzw4",
    "matchYtVideoId": "5lo1L-VtIGw"
  },
  {
    "draftJersey": 207,
    "name": "Paula Úbeda-Portugués",
    "age": 25,
    "foot": "right",
    "height": 167,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/207.jpg",
    "macros": {
      "speed": 76,
      "passing": 44,
      "physical": 75,
      "shooting": 82,
      "talent": 71,
      "defence": 69
    },
    "profileYtVideoId": "l6jDBcgnsyQ",
    "matchYtVideoId": "5lo1L-VtIGw"
  },
  {
    "draftJersey": 208,
    "name": "Patricia Martínez",
    "age": 33,
    "foot": "right",
    "height": 156,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/208.jpg",
    "macros": {
      "speed": 81,
      "passing": 57,
      "physical": 46,
      "shooting": 74,
      "talent": 80,
      "defence": 82
    },
    "profileYtVideoId": "iRS0oRnzw9I",
    "matchYtVideoId": "fx6lySUiZWQ"
  },
  {
    "draftJersey": 209,
    "name": "Paula Navas",
    "age": 24,
    "foot": "right",
    "height": 164,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/209.jpg",
    "macros": {
      "speed": 77,
      "passing": 79,
      "physical": 66,
      "shooting": 64,
      "talent": 80,
      "defence": 81
    },
    "profileYtVideoId": "4lNA2juiLx8",
    "matchYtVideoId": "fx6lySUiZWQ"
  },
  {
    "draftJersey": 211,
    "name": "Queralt Huertas",
    "age": 17,
    "foot": "right",
    "height": 169,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/211.jpg",
    "macros": {
      "speed": 75,
      "passing": 45,
      "physical": 71,
      "shooting": 77,
      "talent": 76,
      "defence": 71
    },
    "profileYtVideoId": "hc81i31DBgk",
    "matchYtVideoId": "fx6lySUiZWQ"
  },
  {
    "draftJersey": 212,
    "name": "Sandra Luzardo",
    "age": 24,
    "foot": "right",
    "height": 170,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/212.jpg",
    "macros": {
      "speed": 76,
      "passing": 57,
      "physical": 56,
      "shooting": 70,
      "talent": 80,
      "defence": 81
    },
    "profileYtVideoId": "-wn5yyj-iwo",
    "matchYtVideoId": "vIs_3tlSW90"
  },
  {
    "draftJersey": 213,
    "name": "Sara París",
    "age": 18,
    "foot": "right",
    "height": 170,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/213.jpg",
    "macros": {
      "speed": 77,
      "passing": 78,
      "physical": 65,
      "shooting": 67,
      "talent": 75,
      "defence": 72
    },
    "profileYtVideoId": "gG4KOQ8Ujro",
    "matchYtVideoId": "AdiKCIODW8k"
  },
  {
    "draftJersey": 214,
    "name": "Sheila Criado",
    "age": 23,
    "foot": "right",
    "height": 165,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/214.jpg",
    "macros": {
      "speed": 79,
      "passing": 60,
      "physical": 52,
      "shooting": 71,
      "talent": 75,
      "defence": 75
    },
    "profileYtVideoId": "4dtG8zNYXDs",
    "matchYtVideoId": "vIs_3tlSW90"
  },
  {
    "draftJersey": 215,
    "name": "Alba Martín",
    "age": 20,
    "foot": "right",
    "height": 170,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/215.jpg",
    "macros": {
      "speed": 83,
      "passing": 93,
      "physical": 56,
      "shooting": 66,
      "talent": 75,
      "defence": 77
    },
    "profileYtVideoId": "26CNfTn4Skk",
    "matchYtVideoId": "PYnu061g3lY"
  },
  {
    "draftJersey": 216,
    "name": "Regi Rodríguez",
    "age": 22,
    "foot": "right",
    "height": 172,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/216.jpg",
    "macros": {
      "speed": 81,
      "passing": 59,
      "physical": 64,
      "shooting": 66,
      "talent": 75,
      "defence": 76
    },
    "profileYtVideoId": "pOueVRlHcP0",
    "matchYtVideoId": "vIs_3tlSW90"
  },
  {
    "draftJersey": 217,
    "name": "Sandra Rovira",
    "age": 35,
    "foot": "right",
    "height": 161,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/217.jpg",
    "macros": {
      "speed": 79,
      "passing": 56,
      "physical": 59,
      "shooting": 69,
      "talent": 82,
      "defence": 81
    },
    "profileYtVideoId": "o64WLADpsM0",
    "matchYtVideoId": "PYnu061g3lY"
  },
  {
    "draftJersey": 218,
    "name": "Sara García",
    "age": 22,
    "foot": "right",
    "height": 167,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/218.jpg",
    "macros": {
      "speed": 78,
      "passing": 60,
      "physical": 60,
      "shooting": 74,
      "talent": 73,
      "defence": 75
    },
    "profileYtVideoId": "EvbX7BOs--0",
    "matchYtVideoId": "vIs_3tlSW90"
  },
  {
    "draftJersey": 219,
    "name": "Rocío López",
    "age": 37,
    "foot": "right",
    "height": 161,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/219.jpg",
    "macros": {
      "speed": 78,
      "passing": 76,
      "physical": 49,
      "shooting": 75,
      "talent": 71,
      "defence": 72
    },
    "profileYtVideoId": "zWmPrfBa0ys",
    "matchYtVideoId": "vIs_3tlSW90"
  },
  {
    "draftJersey": 220,
    "name": "María Martí",
    "age": 33,
    "foot": "left",
    "height": 164,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/220.jpg",
    "macros": {
      "speed": 74,
      "passing": 65,
      "physical": 60,
      "shooting": 77,
      "talent": 75,
      "defence": 77
    },
    "profileYtVideoId": "RSOuJJdjJEo",
    "matchYtVideoId": "vIs_3tlSW90"
  },
  {
    "draftJersey": 221,
    "name": "Sara Olaizola",
    "age": 25,
    "foot": "right",
    "height": 167,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/221.jpg",
    "macros": {
      "speed": 80,
      "passing": 61,
      "physical": 63,
      "shooting": 78,
      "talent": 82,
      "defence": 75
    },
    "profileYtVideoId": "ohVgZ0Et3Tk",
    "matchYtVideoId": "vIs_3tlSW90"
  },
  {
    "draftJersey": 222,
    "name": "Sonia Alonso",
    "age": 34,
    "foot": "left",
    "height": 167,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/222.jpg",
    "macros": {
      "speed": 76,
      "passing": 62,
      "physical": 54,
      "shooting": 64,
      "talent": 78,
      "defence": 74
    },
    "profileYtVideoId": "7X5TUE3E2o0",
    "matchYtVideoId": "vIs_3tlSW90"
  },
  {
    "draftJersey": 223,
    "name": "Sònia Teixiné",
    "age": 25,
    "foot": "right",
    "height": 169,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/223.jpg",
    "macros": {
      "speed": 77,
      "passing": 48,
      "physical": 54,
      "shooting": 80,
      "talent": 75,
      "defence": 75
    },
    "profileYtVideoId": "lXMyAAW70Mc",
    "matchYtVideoId": "vIs_3tlSW90"
  },
  {
    "draftJersey": 224,
    "name": "Sonia Zarza",
    "age": 37,
    "foot": "left",
    "height": 160,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/224.jpg",
    "macros": {
      "speed": 80,
      "passing": 64,
      "physical": 64,
      "shooting": 65,
      "talent": 83,
      "defence": 82
    },
    "profileYtVideoId": "tfEDkn2bFh0",
    "matchYtVideoId": "fx6lySUiZWQ"
  },
  {
    "draftJersey": 225,
    "name": "Susana López",
    "age": 21,
    "foot": "right",
    "height": 170,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/225.jpg",
    "macros": {
      "speed": 79,
      "passing": 49,
      "physical": 54,
      "shooting": 62,
      "talent": 80,
      "defence": 69
    },
    "profileYtVideoId": "TJXQ-ca2ib8",
    "matchYtVideoId": "PYnu061g3lY"
  },
  {
    "draftJersey": 226,
    "name": "Sarai Lucha",
    "age": 35,
    "foot": "right",
    "height": 169,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/226.jpg",
    "macros": {
      "speed": 79,
      "passing": 76,
      "physical": 45,
      "shooting": 75,
      "talent": 76,
      "defence": 82
    },
    "profileYtVideoId": "hirYv2Ln6Pc",
    "matchYtVideoId": "fx6lySUiZWQ"
  },
  {
    "draftJersey": 227,
    "name": "Vanessa Quesada",
    "age": 30,
    "foot": "right",
    "height": 152,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/227.jpg",
    "macros": {
      "speed": 82,
      "passing": 43,
      "physical": 54,
      "shooting": 62,
      "talent": 78,
      "defence": 78
    },
    "profileYtVideoId": "lb-3IWgNLnM",
    "matchYtVideoId": "fx6lySUiZWQ"
  },
  {
    "draftJersey": 228,
    "name": "Ximel Bladh",
    "age": 37,
    "foot": "right",
    "height": 176,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/228.jpg",
    "macros": {
      "speed": 78,
      "passing": 43,
      "physical": 70,
      "shooting": 74,
      "talent": 77,
      "defence": 82
    },
    "profileYtVideoId": "aSxFKIa-i_I",
    "matchYtVideoId": "PYnu061g3lY"
  },
  {
    "draftJersey": 229,
    "name": "Sara Sanaú",
    "age": 31,
    "foot": "right",
    "height": 164,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/229.jpg",
    "macros": {
      "speed": 88,
      "passing": 59,
      "physical": 70,
      "shooting": 73,
      "talent": 75,
      "defence": 75
    },
    "profileYtVideoId": "8OmYOBRRuxQ",
    "matchYtVideoId": "AdiKCIODW8k"
  },
  {
    "draftJersey": 230,
    "name": "Sara Ronzero",
    "age": 21,
    "foot": "right",
    "height": 173,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/230.jpg",
    "macros": {
      "speed": 84,
      "passing": 77,
      "physical": 66,
      "shooting": 71,
      "talent": 77,
      "defence": 74
    },
    "profileYtVideoId": "fNFmbEIkx3A",
    "matchYtVideoId": "AdiKCIODW8k"
  },
  {
    "draftJersey": 231,
    "name": "Silvia Ferrer",
    "age": 38,
    "foot": "right",
    "height": 160,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/231.jpg",
    "macros": {
      "speed": 82,
      "passing": 60,
      "physical": 71,
      "shooting": 79,
      "talent": 79,
      "defence": 78
    },
    "profileYtVideoId": "FaLDS0g6DxM",
    "matchYtVideoId": "AdiKCIODW8k"
  },
  {
    "draftJersey": 232,
    "name": "Stella Llavina",
    "age": 39,
    "foot": "left",
    "height": 166,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/232.jpg",
    "macros": {
      "speed": 78,
      "passing": 90,
      "physical": 64,
      "shooting": 58,
      "talent": 74,
      "defence": 74
    },
    "profileYtVideoId": "wq2cOoc4X_s",
    "matchYtVideoId": "vIs_3tlSW90"
  },
  {
    "draftJersey": 233,
    "name": "Valeria Zapata",
    "age": 24,
    "foot": "right",
    "height": 165,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/233.jpg",
    "macros": {
      "speed": 78,
      "passing": 43,
      "physical": 59,
      "shooting": 69,
      "talent": 76,
      "defence": 69
    },
    "profileYtVideoId": "ee9eCi465Ms",
    "matchYtVideoId": "AdiKCIODW8k"
  },
  {
    "draftJersey": 234,
    "name": "Verónica Parreño",
    "age": 23,
    "foot": "right",
    "height": 180,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/234.jpg",
    "macros": {
      "speed": 79,
      "passing": 59,
      "physical": 77,
      "shooting": 70,
      "talent": 65,
      "defence": 68
    },
    "profileYtVideoId": "l1PEg7Q-Xno",
    "matchYtVideoId": "PYnu061g3lY"
  },
  {
    "draftJersey": 236,
    "name": "Yolanda Bonnín",
    "age": 25,
    "foot": "left",
    "height": 162,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/236.jpg",
    "macros": {
      "speed": 82,
      "passing": 59,
      "physical": 75,
      "shooting": 88,
      "talent": 84,
      "defence": 78
    },
    "profileYtVideoId": "_u1TWyVTndk",
    "matchYtVideoId": "PYnu061g3lY"
  },
  {
    "draftJersey": 237,
    "name": "Yesenia Villalba",
    "age": 21,
    "foot": "right",
    "height": 160,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/237.jpg",
    "macros": {
      "speed": 74,
      "passing": 60,
      "physical": 71,
      "shooting": 64,
      "talent": 79,
      "defence": 86
    },
    "profileYtVideoId": "mNpvsYvEVZE",
    "matchYtVideoId": "PYnu061g3lY"
  },
  {
    "draftJersey": 238,
    "name": "Ylenia Cirrincione",
    "age": 23,
    "foot": "right",
    "height": 173,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/238.jpg",
    "macros": {
      "speed": 73,
      "passing": 58,
      "physical": 52,
      "shooting": 81,
      "talent": 77,
      "defence": 77
    },
    "profileYtVideoId": "-mHJRcoje1g",
    "matchYtVideoId": "fx6lySUiZWQ"
  },
  {
    "draftJersey": 240,
    "name": "Vinyet Clua",
    "age": 21,
    "foot": "right",
    "height": 158,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/240.jpg",
    "macros": {
      "speed": 82,
      "passing": 63,
      "physical": 80,
      "shooting": 56,
      "talent": 76,
      "defence": 82
    },
    "profileYtVideoId": "giVeDJ-j1RA",
    "matchYtVideoId": "fx6lySUiZWQ"
  },
  {
    "draftJersey": 241,
    "name": "Xènia Miralles",
    "age": 22,
    "foot": "right",
    "height": 155,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/241.jpg",
    "macros": {
      "speed": 80,
      "passing": 44,
      "physical": 67,
      "shooting": 62,
      "talent": 73,
      "defence": 72
    },
    "profileYtVideoId": "WxHy8HQaqLU",
    "matchYtVideoId": "AdiKCIODW8k"
  },
  {
    "draftJersey": 242,
    "name": "Anna Costa",
    "age": 40,
    "foot": "right",
    "height": 166,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/242.jpg",
    "macros": {
      "speed": 74,
      "passing": 76,
      "physical": 56,
      "shooting": 69,
      "talent": 78,
      "defence": 77
    },
    "profileYtVideoId": "aFTZcd8Gx7s",
    "matchYtVideoId": "PYnu061g3lY"
  },
  {
    "draftJersey": 243,
    "name": "Adriana Pérez",
    "age": 29,
    "foot": "right",
    "height": 170,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/243.jpg",
    "macros": {
      "speed": 77,
      "passing": 60,
      "physical": 66,
      "shooting": 73,
      "talent": 82,
      "defence": 78
    },
    "profileYtVideoId": "Xi9K7JgnuMY",
    "matchYtVideoId": "PYnu061g3lY"
  },
  {
    "draftJersey": 244,
    "name": "Zoraida Pichardo",
    "age": 27,
    "foot": "left",
    "height": 165,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/244.jpg",
    "macros": {
      "speed": 80,
      "passing": 61,
      "physical": 45,
      "shooting": 91,
      "talent": 81,
      "defence": 73
    },
    "profileYtVideoId": "h7NsXrOSMF0",
    "matchYtVideoId": "AdiKCIODW8k"
  },
  {
    "draftJersey": 245,
    "name": "Carme Cendra",
    "age": 18,
    "foot": "right",
    "height": 162,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/245.jpg",
    "macros": {
      "speed": 78,
      "passing": 65,
      "physical": 65,
      "shooting": 62,
      "talent": 80,
      "defence": 80
    },
    "profileYtVideoId": "c7tLslrxACc",
    "matchYtVideoId": "fx6lySUiZWQ"
  },
  {
    "draftJersey": 246,
    "name": "Alexia Carbonell",
    "age": 21,
    "foot": "right",
    "height": 175,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/246.jpg",
    "macros": {
      "speed": 78,
      "passing": 60,
      "physical": 60,
      "shooting": 70,
      "talent": 73,
      "defence": 72
    },
    "profileYtVideoId": "q8fu0jrNzLo",
    "matchYtVideoId": "UtNVRuD9tYk"
  },
  {
    "draftJersey": 247,
    "name": "Júlia Prat",
    "age": 21,
    "foot": "right",
    "height": 162,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/247.jpg",
    "macros": {
      "speed": 78,
      "passing": 76,
      "physical": 62,
      "shooting": 75,
      "talent": 73,
      "defence": 73
    },
    "profileYtVideoId": "AI0EWkaOKjw",
    "matchYtVideoId": "AdiKCIODW8k"
  },
  {
    "draftJersey": 248,
    "name": "Carmina Veas",
    "age": 27,
    "foot": "right",
    "height": 159,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/248.jpg",
    "macros": {
      "speed": 82,
      "passing": 79,
      "physical": 53,
      "shooting": 74,
      "talent": 76,
      "defence": 75
    },
    "profileYtVideoId": "tNnhP40p7yg",
    "matchYtVideoId": "AdiKCIODW8k"
  },
  {
    "draftJersey": 249,
    "name": "Míriam Jiménez",
    "age": 22,
    "foot": "left",
    "height": 160,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft/249.jpg",
    "macros": {
      "speed": 79,
      "passing": 63,
      "physical": 47,
      "shooting": 82,
      "talent": 80,
      "defence": 81
    },
    "profileYtVideoId": "S7N6fclTosg",
    "matchYtVideoId": "PYnu061g3lY"
  }
]
